// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.invalid-project-modal_modal-content_ebgOe {
  max-width: 480px;
  margin-top: 50px;
}

.invalid-project-modal_body_M4G_T {
  background: var(--ui-modal-background);
  padding: 1.5rem 2.25rem;
  max-height: calc(100vh - 150px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.invalid-project-modal_error_MM0Kd {
  font-family: monospace;
  height: 125px;
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  padding: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid var(--ui-black-transparent);
  background-color: var(--input-background);
  color: inherit;
}

.invalid-project-modal_button_ukoaD {
  font: inherit;
  font-weight: bold;
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid var(--ui-black-transparent);
  background-color: var(--looks-secondary);
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-invalid-project-modal/invalid-project-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,6CAA6C;EAC7C,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;EAC7C,wCAAwC;EACxC,YAAY;AACd","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.modal-content {\n  max-width: 480px;\n  margin-top: 50px;\n}\n\n.body {\n  background: var(--ui-modal-background);\n  padding: 1.5rem 2.25rem;\n  max-height: calc(100vh - 150px);\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.error {\n  font-family: monospace;\n  height: 125px;\n  width: 100%;\n  box-sizing: border-box;\n  resize: vertical;\n  padding: 0.5rem;\n  border-radius: 0.5rem;\n  border: 1px solid var(--ui-black-transparent);\n  background-color: var(--input-background);\n  color: inherit;\n}\n\n.button {\n  font: inherit;\n  font-weight: bold;\n  padding: 0.75rem 1rem;\n  border-radius: 0.25rem;\n  border: 1px solid var(--ui-black-transparent);\n  background-color: var(--looks-secondary);\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `invalid-project-modal_modal-content_ebgOe`,
	"modalContent": `invalid-project-modal_modal-content_ebgOe`,
	"body": `invalid-project-modal_body_M4G_T`,
	"error": `invalid-project-modal_error_MM0Kd`,
	"button": `invalid-project-modal_button_ukoaD`
};
export default ___CSS_LOADER_EXPORT___;
